module.exports = __webpack_public_path__ + "static/img/cycleAI-plain.4afa22b.svg";